import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useAuthStore } from '@/lib/core/stores/useAuthStore';
import { useCartStore } from '@/lib/core/stores/useCartStore';

/**
 * Keeps the cart badge's item count fresh at points the full `hydrate()`
 * (item list + prices, used by Bag/Delivery/Checkout) isn't triggered: cold
 * start and app resume from background. Uses the lightweight
 * /me/cart/shop/count endpoint and never touches `isHydrated`, which gates
 * checkout readiness elsewhere.
 */
export function useCartCountSync() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const hydrateCount = useCartStore(state => state.hydrateCount);

  useEffect(() => {
    if (!isAuthenticated) return;
    hydrateCount();
  }, [isAuthenticated, hydrateCount]);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const listenerPromise = App.addListener('resume', () => {
      if (useAuthStore.getState().isAuthenticated) {
        hydrateCount();
      }
    });

    return () => {
      listenerPromise.then(listener => listener.remove());
    };
  }, [hydrateCount]);
}
